const ITEMS = ["Technical SEO", "On-Page SEO", "Content SEO", "Local SEO", "E-Commerce SEO", "Off-Page SEO", "SMO"];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-rw-border bg-rw-bg2 py-5 overflow-hidden" data-testid="trust-strip">
      <div className="flex w-max animate-marquee items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10" data-testid={i < ITEMS.length ? `trust-item-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : undefined}>
            <span className={`font-jakarta font-bold tracking-wide whitespace-nowrap ${item === "SMO" ? "text-rw-dim text-base" : "text-rw-text text-lg"}`}>
              {item}
            </span>
            <span className={`h-1.5 w-1.5 rounded-full ${item === "SMO" ? "bg-rw-dim" : "bg-rw-green"}`} aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
